import db from "astrid-firebase/src/db";
import { useLoadingValues } from "astrid-firestore/src/hooks";
import useCollectionDataOnce from "astrid-firestore/src/hooks/useCollectionDataOnce";

export default function useExchangeRate(date) {
	const [[latestExchangeRate, dateExchangeRate], loading, error] = useLoadingValues(
		useCollectionDataOnce(db.collection("exchangeRates").orderBy("timestamp", "desc").limit(1)),
		useCollectionDataOnce(
			date && db.collection("exchangeRates").where("timestamp", "<=", date).orderBy("timestamp", "desc").limit(1),
		),
	);

	const exchangeRate = dateExchangeRate?.[0] || latestExchangeRate?.[0] || null;

	return [exchangeRate, loading, error];
}
